export default {
  title: '商品を選択',
};
